<div class="header__background"></div>
<div class="header__safe-area-spacer"></div>
<div class="header__action-bar" [ngClass]="{hide: showSearchInput}">
  <app-svg-icon
    class="icon"
    [src]="'logo.svg'"
    [svgStyle]="{ 'width.px': '202', 'height.px': '40' }"
  ></app-svg-icon>
  <div class="header__actions">
    @if (showSearch) {
      <app-icon-button (action)="showSearchInput = true" [addPadding]="true" [style]="{width: '32', height: '32'}" src="icons/32/search.svg"></app-icon-button>
    }
    <app-profile-icon (action)="SetEvent($event, DashboardRoutesType.Settings)" [initials]="initials$ | async" [clickable]="profileClickable"></app-profile-icon>
  </div>
</div>
<div class="spacer-2"></div>
<div class="header__content">
  @if (showGreeting) {
    <h1>{{ 'PAGES.DASHBOARD.HEADER.TITLE' | translate:{name: fullname$ | async} }}</h1>
  }
  <p class="label">{{ subtitle || ('PAGES.DASHBOARD.HEADER.TEXT' | translate) }}</p>
</div>
<div class="spacer-5"></div>
@if (showSearchInput) {
  <app-input-search-text [@enterLeave] (action)="SetEvent($event)" id="search-input" [autofocus]="true" [closeInputOption]="true"></app-input-search-text>
}
@if (((searchResult$ | async) || firstSearchHappendAlready) && currentTextFilter.value !== '') {
  <div class="header__search-results">
    <div class="header__search-results-header"></div>
    <div class="header__search-results-wrapper content">
      @if (searchResult$ | async; as searchResults) {
        @if (searchResults.length > 0) {
          <p class="filter">{{ 'PAGES.DASHBOARD.HEADER.SEARCH_RESULT.TEXT' | translate:{value: (searchResult$ | async).length} }}</p>
        }
        @if (searchResults.length == 0) {
          <p class="filter center">{{ 'PAGES.DASHBOARD.HEADER.SEARCH_RESULT.NO_RESULTS' | translate }}</p>
        }
        <div class="spacer"></div>
        @for (searchResult of searchResults; track searchResult.id) {
          <app-info-card
            (action)="SetEvent($event, DashboardRoutesType.NewsDetail, searchResult.id)"
            [title]="searchResult.attributes.field_teaser_title || searchResult.attributes.title"
            [infoDate]="searchResult.attributes.publication_date"
            [new]="!searchResult.attributes.is_read"
            >
          </app-info-card>
        }
      } @else {
        <app-loading></app-loading>
      }
    </div>
  </div>
}
